import { Button, ErrorMessage, Icon, Text } from "@simplybusiness/mobius";
import { penToSquare } from "@simplybusiness/icons";
import type { TradeQuestionSelectedProps } from ".";

const DEFAULT_LABEL = "Trade/profession";

export const TradeQuestionSelectedUK = ({
  trade,
  onEditTrade,
  primaryText,
  errorMessage,
}: TradeQuestionSelectedProps) => (
  <div
    className="mobius-trade-question--selected"
    data-testid="trade-selected-uk"
  >
    <div className="mobius-trade-question__grid-container">
      <div className="mobius-trade-question__content">
        <Text
          elementType="p"
          className="mobius-trade-question__selected-text"
          data-testid="trade-selected-text"
        >
          <strong>{primaryText || DEFAULT_LABEL}</strong>
        </Text>

        <Text elementType="p" className="mobius-trade-question__selected-text">
          {trade.value}
        </Text>
      </div>

      <Button
        className="mobius-question__help-link mobius-trade-question__edit-btn"
        onClick={onEditTrade}
        variant="link"
        size="sm"
        type="button"
        aria-label="Edit selected trade or profession"
      >
        <span>Edit</span>
        <Icon fixedWidth icon={penToSquare} size="sm" />
      </Button>
    </div>
    {errorMessage && <ErrorMessage errorMessage={errorMessage} />}
  </div>
);
